import type { AtomModel } from '@/app/editor/iframe/atom/Atom.model';
import { getWidthPercentage } from '@/app/utils/helpers';
import HELPER from '@/app/utils/HELPER';
import { AtomTargetHandler } from './AtomTargetHandler';

/**
 * ShCssNotSelector
 */
export class ShCssNotSelector extends AtomTargetHandler {
  /**
   * read
   * @param options options
   * @param options.screenType screenType
   * @param options.$activePanel $activePanel
   */
  read(options: { screenType: any; $activePanel: JQuery; $atom: JQuery; atomModel: AtomModel }) {
    this.set$el(options.$atom);
    this.setAtomModel(options.atomModel);
    this.setting.targetSelector = this.getAtomModel().class;
    const targetSelector = this.setting.targetSelector as string;
    const $self = this.getAtomTarget('read', this);
    const style = this.getAtomModel().style;
    let value: any = '';
    const saveSettingRequire = this.setting.require;
    value = HELPER.getValueFromCSS(
      $self,
      style,
      this.setting.property,
      options.screenType,
      this.setting.targetSelector,
    );
    if (this.setting.name == 'height' && value != '') {
      this.setting.require = false; // Tắt require khi HELPER.getValueFromCSS lấy được giá trị
    }
    if ((this.setting.name == 'width' || this.setting.name == 'height') && value === '') {
      value = 'auto';
    }

    if (this.setting.options?.length) {
      for (let i = 0; i < this.setting.options.length; i++) {
        const option = this.setting.options[i];
        if (option.value == value) {
          value = option.key;
        }
      }
    }
    if (!value || value == undefined) {
      value = this.setting.default_value ? this.setting.default_value : '';
    }
    if (this.setting.require) {
      value = $self.css(this.setting.property); // Sử dụng khi các phần xử lý trên không lấy được giá trị
    }
    if (this.setting.fieldType == 'color') {
      if (!value || value == 'none') {
        value = this.setting.default_value;
      }
      value = HELPER.rgb2hex(value);
    }
    if (value != '' || !value) {
      // convert px to em
      if (this.setting.name == 'line-height' && this.setting.unit == 'em' && value.indexOf('px') !== -1) {
        const fontSize = $self.find(targetSelector).css('font-size');
        try {
          const val = parseInt(value) / parseInt(fontSize);
          value = val.toFixed(2) + 'em';
        } catch (e) {
          // eslint-disable-next-line no-console
          console.log('fail to convert px to em');
        }
      }
      if (this.setting.name == 'width' && this.setting.unit == '%' && value.indexOf('px') !== -1) {
        const $target = $self.find(targetSelector);
        value = getWidthPercentage($target) + '%';
      }
    }
    if (value === undefined || value === '') {
      value = '';
      options.$activePanel.find(`[name="${this.setting.name}"]`).attr('default_value', value).trigger('value-change');
    }
    options.$activePanel.find(`[name="${this.setting.name}"]`).attr('value', value).val(value).trigger('value-change');
    this.setting.require = saveSettingRequire;
    return { value: value };
  }

  /**
   * write
   * @param value value
   * @param options options
   * @param options.screenType screenType
   * @returns style
   */
  write(
    value: string,
    options: {
      screenType: any;
      $atom: JQuery;
      atomModel: AtomModel;
    },
  ) {
    this.set$el(options.$atom);
    this.setAtomModel(options.atomModel);

    const $self = this.getAtomTarget('write', this);
    let style = this.getAtomModel().style;
    const refreshType = this.setting.refreshType ? this.setting.refreshType : 'css';
    if (this.setting.options?.length) {
      for (let i = 0; i < this.setting.options.length; i++) {
        const option = this.setting.options[i];
        if (option.key == value) {
          value = option.value;
        }
      }
    }
    let deOptions = [];
    if (this.setting.name == 'height') {
      if (value != 'auto') {
        deOptions = [
          {
            key: this.setting.property,
            value: value,
          },
          {
            key: 'line-height',
            value: value,
          },
        ];
      } else {
        deOptions = [
          {
            key: this.setting.property,
            value: value,
          },
          {
            key: 'line-height',
            value: '',
          },
        ];
      }
    } else {
      deOptions = [
        {
          key: this.setting.property,
          value: value,
        },
      ];
    }
    style = HELPER.designOptions2Style($self, options.screenType, style, deOptions, this.getAtomModel().class);
    return {
      refreshType: refreshType,
      style: style,
    };
  }
  /**
   * getAtomModel
   * @returns atomModel :jQuery
   */
  getAtomModel() {
    return this.atomModel;
  }
}
